import {Platform_Type} from "./EvntTypes";

export const SetPlatformType = (val) => {
  return {
    type: Platform_Type,
    data: val,
  }
}